// extracted by mini-css-extract-plugin
module.exports = {"label":"SetResponsibleModal_label__1xsVV","errorMessage":"SetResponsibleModal_errorMessage__3KQjY"};